/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pl_Pnk_Tea_Purchase_HintInputs */

const vi_pl_pnk_tea_purchase_hint = /** @type {(inputs: Pl_Pnk_Tea_Purchase_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hệ thống sẽ tự chia thành nhiều lô theo định mức lô chè mua.`)
};

/**

* @param {Pl_Pnk_Tea_Purchase_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pl_pnk_tea_purchase_hint = /** @type {((inputs?: Pl_Pnk_Tea_Purchase_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pl_Pnk_Tea_Purchase_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pl_pnk_tea_purchase_hint(inputs)
});